import { Platform } from 'react-native';

// Try to import API_URL from @env, fallback to undefined if not available
let API_URL: string | undefined;
try {
  API_URL = require('@env').API_URL;
} catch (error) {
  console.warn('Could not load API_URL from @env, using fallback');
  API_URL = undefined;
}

export const API_CONFIG = {
  BASE_URL:
    API_URL ||
    Platform.select({
      web: 'https://calebo-api.pipe.com.ar',
      default: 'https://calebo-api.pipe.com.ar', // Use production URL for mobile
    }),

  ENDPOINTS: {
    STATISTICS: {
      ISSUER_RANKING: '/api/statistics/issuer-ranking',
      ISSUER_RANKING_NOTIONAL: '/api/statistics/issuer-ranking-notional',
      NOTIONAL_BY_CURRENCY: '/api/statistics/notional-by-currency',
      PRODUCTS_NEAR_EXPIRY: '/api/statistics/products-near-expiry',
      PRODUCTS: '/api/statistics/products',
      USER_STATS: '/api/statistics/user-stats',
      TOP_UNDERLYING_EXPOSURE: '/api/statistics/top-underlying-exposure',
      TOP_UNDERLYING_EXPOSURE_TEST: '/api/statistics/top-underlying-exposure-test',
    },
    PRODUCTS: {
      LIST: '/api/products',
      TYPES: '/api/products/types',
      ASSET_CLASSES: '/api/products/asset-classes',
      FILTER_OPTIONS: '/api/products/filter-options',
      ADDRESS_REPORTS: '/api/products/address-reports',
      OWNERSHIP_SCOPE_AVAILABILITY: '/api/products/ownership-scope-availability',
    },
    FAVOURITES: {
      LIST: '/api/favourites',
      WATCHLIST: '/api/favourites/watchlist',
    },
    CUSTOM_REPORTS: {
      LIST: '/api/custom-reports',
      COLLEAGUES: '/api/custom-reports/colleagues',
    },
    EVENTS: {
      DASHBOARD: '/api/events/dashboard',
      LIST: '/api/events/list',
      CALENDAR: '/api/events/calendar',
    },
    ANALYTICS: {
      HEARTBEAT: '/api/presence/heartbeat',
      OVERVIEW_MONTHLY: '/api/analytics/overview/monthly',
      USERS_MONTHLY: '/api/analytics/users/monthly',
      USER_MONTHLY: (userId: string) => `/api/analytics/users/${userId}/monthly`,
      TOP_ACTIVE: '/api/analytics/users/top-active',
    },
    NOTIFICATIONS: {
      LIST: '/api/notifications',
      DELETE_ALL: '/api/notifications',
      MARK_READ: '/api/notifications/:id/read',
      MARK_ALL_READ: '/api/notifications/read-all',
      PREFERENCES: '/api/notifications/preferences',
      EMAIL_PREVIEW: '/api/notifications/email-preview',
    },
    AUTH: {
      LOGIN: '/api/auth/login',
      LOGOUT: '/api/auth/logout',
      REFRESH: '/api/auth/refresh',
      FORGOT_PASSWORD: '/api/auth/forgot-password',
      RESET_PASSWORD: '/api/auth/reset-password',
      IMPERSONATE: '/api/auth/impersonate',
      STOP_IMPERSONATION: '/api/auth/stop-impersonation',
      PREFERENCES: '/api/auth/preferences',
      AVATAR: '/api/auth/avatar',
    },
    USERS: {
      DASHBOARD_LAYOUT: '/api/users/me/dashboard-layout',
    },
  },

  REQUEST: {
    TIMEOUT: 10000,
    RETRY_ATTEMPTS: 3,
    RETRY_DELAY: 1000,
  },

  HEADERS: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
};

export const getEndpoint = (endpoint: string) => `${API_CONFIG.BASE_URL}${endpoint}`;
